import React, { useState, useEffect } from 'react';
import Home from './pages/Home';
import FlappyBird from './pages/FlappyBird';
import Snake from './pages/Snake';
import Tetris from './pages/Tetris';
import Pong from './pages/Pong';
import Minesweeper from './pages/Minesweeper';
import Wordle from './pages/Wordle';
import GeometryArrow from './pages/gd-arrow';
import MemoryMatch from './pages/MemoryMatch';
import HigherLower from './pages/HigherLower';
import WhackMole from './pages/WhackMole';
import Game2048 from './pages/Game2048';
import AlchemyShop from './pages/AlchemyShop';
import './App.css';

function getPage() {
  const hash = window.location.hash.replace('#', '') || 'home';
  return hash;
}

export default function App() {
  const [page, setPage] = useState(getPage);

  useEffect(() => {
    const onHash = () => setPage(getPage());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const navigate = (path) => {
    window.location.hash = path;
  };

  return (
    <div className="app">
      {page === 'home'          && <Home          navigate={navigate} />}
      {page === 'flappy-bird'   && <FlappyBird    navigate={navigate} />}
      {page === 'snake'         && <Snake         navigate={navigate} />}
      {page === 'tetris'        && <Tetris        navigate={navigate} />}
      {page === 'pong'          && <Pong          navigate={navigate} />}
      {page === 'minesweeper'   && <Minesweeper   navigate={navigate} />}
      {page === 'wordle'        && <Wordle        navigate={navigate} />}
      {page === 'gd-arrow'      && <GeometryArrow navigate={navigate} />}
      {page === 'memory-match'  && <MemoryMatch   navigate={navigate} />}
      {page === 'higher-lower'  && <HigherLower   navigate={navigate} />}
      {page === 'whack-mole'    && <WhackMole     navigate={navigate} />}
      {page === 'game-2048'     && <Game2048      navigate={navigate} />}
      {page === 'alchemy-shop'  && <AlchemyShop   navigate={navigate} />}
    </div>
  );
}